import { React, useState, useEffect  } from 'react';
import { Table } from 'react-bootstrap';
import * as api from 'services/api';
import { useTranslation } from 'react-i18next';

export function EventList({ equipmentIdent, callHistory, setRequestPseudocodes, overridesPairs }) {
    const { t } = useTranslation();
    const [lockTime, setLockTime] = useState(null);
    const [formattedCallHistory, setFormattedCallHistory] = useState([]);
    const [newCalls, setNewCalls] = useState([]);

    useEffect(() => {
    const fetchLockTime = async () => {
      const response = await api.getLockTime(equipmentIdent);
      if (response.status === 200) {
        setLockTime(response.data.message); 
      }
    };
    fetchLockTime();
    }, [equipmentIdent]);


    useEffect(() => {
        setFormattedCallHistory([]);
        setNewCalls([]);
        if (lockTime && callHistory.length > 0) {

            callHistory.map((call) => {
                                
                const eventDateTime = new Date(call.arrivalTime);

                const lockDateTime = new Date();
                // Añadir la hora del bloqueo al formato de fecha, para poder comparar ambas fechas
                const lockTimeParts = lockTime.split(':');
                lockDateTime.setHours(lockTimeParts[0]);
                lockDateTime.setMinutes(lockTimeParts[1]);
                lockDateTime.setSeconds(lockTimeParts[2] || 0);
                var isBeforeLockTime = true;

                const exist = overridesPairs.some(rango => {
                    const [pseudo, pseudoOverride] = rango.split('-').map(Number);
                    return pseudo === call.pseudoCodeId || pseudoOverride === call.pseudoCodeId;
                }); 

                if (eventDateTime > lockDateTime && exist) {
                    isBeforeLockTime = false;
                    setNewCalls(prev => [
                        ...prev,
                        { pseudoCodeId: call.pseudoCodeId, pseudoCode: call.pseudoCode, callDate: call.arrivalTime, callHistoryId: call.callHistoryId }
                    ]);
                    
                }
                const colorStyle = isBeforeLockTime ? 'red' : 'green';

                setFormattedCallHistory(prev => [
                    ...prev,
                    {
                        formattedDate: eventDateTime.toLocaleDateString(),
                        formattedTime: eventDateTime.toLocaleTimeString(),
                        pseudoCodeText: call.pseudoCodeText,
                        pseudoCodeId: call.pseudoCodeId,
                        colorStyle: colorStyle
                    }
                ]);

            });

            

            
        }
    }, [lockTime,callHistory]);

    useEffect(() => {
        console.log(newCalls);
        if (newCalls.length > 0) setRequestPseudocodes(newCalls.filter(
            (call, index, self) =>
                index === self.findIndex(c => c.pseudoCodeId === call.pseudoCodeId)
        ));
    }, [newCalls]);
  return (
    <div className="EventList">
      {callHistory.length > 0 ? (
        <Table size="sm" className='mb-0 mt-2'>
          <thead>
            <tr style={{ fontSize: '13px' }}>
                          <th>{t('eListHour')}</th>
                          <th>{t('eListCode')}</th>
                          <th>{t('eListDescription')}</th>
                
            </tr>
          </thead>
          <tbody>
            {formattedCallHistory.map((call, index) => (
              <tr key={index} style={{ fontSize: '13px', fontWeight: 'normal' }}>
                    <td style={{ color: call.colorStyle }}>{call.formattedDate + ' ' + call.formattedTime}</td>
                    <td style={{ color: 'gray' }}>{call.pseudoCodeId}</td>
                <td style={{ color: 'gray' }}>{call.pseudoCodeText}</td>
              </tr>
            ))}
          </tbody>
        </Table>
          ) : (<p>{t('eListNoData')}</p>)}
    </div>
  );
}